// useUpdatePin — mutation to pin or unpin a thread.
// Invalidates the thread list on success.

import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createApiClient } from '@/shared/api';
import { getToken } from '@/shared/auth';
import { readEnv } from '@/shared/config';
import { createThreadApi } from '../api/threadApi';
import { invalidateThreadList } from './invalidate';

function getApi() {
  return createThreadApi(createApiClient({
    baseUrl: readEnv('VITE_API_BASE_URL') ?? '',
    auth: { getToken },
  }));
}

export function useUpdatePin() {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: ({ threadId, pinned }: { threadId: string; pinned: boolean }) =>
      getApi().updatePin(threadId, pinned),
    onSuccess: () => {
      void invalidateThreadList(queryClient);
    },
  });

  return {
    updatePin: mutation.mutateAsync,
    isPending: mutation.isPending,
    error: mutation.error,
  };
}
